module.exports = __webpack_public_path__ + "media/v2/components/shared/Image/team-48b8f1b70a99b1f79c8cd84b429f4fa1.png";